// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610202153/js/" + chunkId + "." + {"44":"ded42331","225":"8556a024","481":"042bc6e6","486":"af75477a","770":"7ccda574"}[chunkId] + ".0.6815237211233702.chunk.js";
};